import { render, staticRenderFns } from "./NoContent.vue?vue&type=template&id=41d47c68&scoped=true"
import script from "./noContent.ts?vue&type=script&lang=ts&external"
export * from "./noContent.ts?vue&type=script&lang=ts&external"
import style0 from "./NoContent.vue?vue&type=style&index=0&id=41d47c68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d47c68",
  null
  
)

export default component.exports